import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    companyName: 'ChatFlow',
    cnpj: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    phone: '',
    email: '',
    website: '',
    instagram: '',
    facebook: '',
    linkedin: '',
    description: '',
    dpoName: '',
    dpoEmail: ''
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await api.get('/settings');
      setSettings(response.data);
    } catch (error) {
      console.error(t('set.loadError'), error);
    } finally {
      setLoading(false);
    }
  };

  const refreshSettings = async () => {
    await loadSettings();
  };

  // Helper para endereco completo
  const getFullAddress = () => {
    const parts = [];
    if (settings.address) parts.push(settings.address);
    if (settings.city) parts.push(settings.city);
    if (settings.state) parts.push(settings.state);
    if (settings.zipCode) parts.push(`CEP: ${settings.zipCode}`);
    return parts.join(', ');
  };

  // Helper para cidade/estado
  const getCityState = () => {
    if (settings.city && settings.state) {
      return `${settings.city} - ${settings.state}`;
    }
    return settings.city || settings.state || '';
  };

  return (
    <SettingsContext.Provider value={{
      settings,
      loading,
      refreshSettings,
      getFullAddress,
      getCityState
    }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};
